<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                <v-icon class="me-2">mdi-filter</v-icon>
                Bonus Aging Report Filter
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-form @submit.prevent="handleFilterSubmit">
                  <v-row class="py-2" dense>
                    <v-col cols="12" md="3">
                      <v-select
                        v-model="filters.year"
                        :items="yearOptions"
                        label="Year"
                        variant="outlined"
                        density="compact"
                        clearable
                        hide-details="auto"
                      />
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-select
                        v-model="filters.month"
                        :items="months"
                        item-title="label"
                        item-value="value"
                        label="Month"
                        variant="outlined"
                        density="compact"
                        clearable
                        hide-details="auto"
                      />
                    </v-col>
                    <v-col cols="12" md="2" class="d-flex align-end ga-2">
                      <v-btn
                        type="submit"
                        color="primary"
                        :loading="loading"
                        prepend-icon="mdi-magnify"
                        class="pl-2"
                        density="compact"
                        height="40"
                        variant="flat"
                      >
                        Search
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>

      <!-- Summary Cards -->
      <!-- <v-row v-if="reportData.length > 0" class="mt-2">
        <v-col cols="12" md="3">
          <v-card variant="outlined" color="warning">
            <v-card-text>
              <div class="text-caption text-medium-emphasis">Total Outstanding</div>
              <div class="text-h6 font-weight-bold">{{ formatNumber(summary.total_remaining) }}</div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="3">
          <v-card variant="outlined" color="info">
            <v-card-text>
              <div class="text-caption text-medium-emphasis">Total Records</div>
              <div class="text-h6 font-weight-bold">{{ summary.total_records }}</div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="3">
          <v-card variant="outlined" color="orange">
            <v-card-text>
              <div class="text-caption text-medium-emphasis">Unpaid Records</div>
              <div class="text-h6 font-weight-bold">{{ summary.unpaid_count }}</div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="3">
          <v-card variant="outlined" color="blue">
            <v-card-text>
              <div class="text-caption text-medium-emphasis">Partial Records</div>
              <div class="text-h6 font-weight-bold">{{ summary.partial_count }}</div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row> -->

      <v-row class="mt-2">
        <v-col cols="12">
          <v-expansion-panels v-model="listPanel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                <v-icon class="me-2">mdi-clock-alert-outline</v-icon>
                Bonus Aging Report
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-row class="py-2">
                  <v-col md="4" cols="12">
                    <v-text-field
                      v-model="search"
                      append-inner-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                      density="compact"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      class="pl-2"
                      clearable
                    />
                  </v-col>

                  <v-col md="5" cols="12">
                    <div class="d-flex align-center flex-column">
                      <v-btn-group
                        variant="outlined"
                        density="compact"
                        size="x-small"
                        divided
                      >
                        <v-btn
                          prepend-icon="mdi-download"
                          variant="flat"
                          color="success"
                          @click="exportToCSV"
                          :disabled="reportData.length === 0"
                        >
                          CSV
                        </v-btn>
                        <v-btn
                          prepend-icon="mdi-download"
                          variant="flat"
                          color="primary"
                          @click="exportToExcel"
                          :disabled="reportData.length === 0"
                        >
                          EXCEL
                        </v-btn>
                        <v-btn
                          prepend-icon="mdi-download"
                          variant="flat"
                          color="red"
                          @click="exportToPDF"
                          :disabled="reportData.length === 0"
                        >
                          PDF
                        </v-btn>
                      </v-btn-group>
                    </div>
                  </v-col>
                </v-row>

                <v-data-table
                  :headers="tableHeaders"
                  :items="reportData"
                  :loading="loading"
                  :search="search"
                  class="mt-4"
                  density="compact"
                  hover
                  :items-per-page="itemsPerPage"
                  v-model:items-per-page="itemsPerPage"
                >
                  <template #item.index="{ index }">
                    {{ index + 1 }}
                  </template>
                  <template #loading>
                    <div class="py-6 text-center text-medium-emphasis">
                      Loading bonus aging report...
                    </div>
                  </template>
                  <template #item.employee_code="{ item }">
                    <span class="font-weight-medium">{{ item.employee?.code || '—' }}</span>
                  </template>
                  <template #item.employee_name="{ item }">
                    {{ item.employee?.name || '—' }}
                  </template>
                  <template #item.year="{ item }">
                    {{ item.year || item.bonusProcessMaster?.year || '—' }}
                  </template>
                  <template #item.month="{ item }">
                    {{ formatMonth(item.month || item.bonusProcessMaster?.month) }}
                  </template>
                  <template #item.bonus_amount="{ item }">
                    <div class="text-center">{{ formatNumber(item.bonus_amount) }}</div>
                  </template>
                  <template #item.payable_amount="{ item }">
                    <div class="text-center">{{ formatNumber(item.payable_amount) }}</div>
                  </template>
                  <template #item.paid_amount="{ item }">
                    <div class="text-center">{{ formatNumber(item.paid_amount) }}</div>
                  </template>
                  <template #item.remaining_amount="{ item }">
                    <div class="text-center">
                      <v-chip
                        :color="getRemainingAmountColor(item.remaining_amount)"
                        size="small"
                        variant="tonal"
                      >
                        {{ formatNumber(item.remaining_amount) }}
                      </v-chip>
                    </div>
                  </template>
                  <template #item.aging_days="{ item }">
                    <div class="text-center">
                      <v-chip
                        :color="getAgingColor(item.aging_days)"
                        size="small"
                        variant="tonal"
                      >
                        {{ item.aging_days }} days
                      </v-chip>
                    </div>
                  </template>
                  <template #item.payment_status="{ item }">
                    <v-chip
                      :color="getPaymentStatusColor(item.payment_status)"
                      size="small"
                      class="text-capitalize"
                    >
                      {{ formatPaymentStatus(item.payment_status) }}
                    </v-chip>
                  </template>
                  <template #body.append v-if="reportData && reportData.length > 0">
                    <tr class="v-data-table__tr" style="font-weight: bold; background-color: #f5f5f5;">
                      <td class="v-data-table__td text-center">—</td>
                      <td colspan="4" class="v-data-table__td text-end">
                        <strong>Total:</strong>
                      </td>
                      <td class="v-data-table__td text-center">
                        <strong>{{ formatNumber(summary.total_bonus) }}</strong>
                      </td>
                      <td class="v-data-table__td text-center">
                        <strong>{{ formatNumber(summary.total_payable) }}</strong>
                      </td>
                      <td class="v-data-table__td text-center">
                        <strong>{{ formatNumber(summary.total_paid) }}</strong>
                      </td>
                      <td class="v-data-table__td text-center">
                        <strong>{{ formatNumber(summary.total_remaining) }}</strong>
                      </td>
                      <td class="v-data-table__td text-center">—</td>
                      <td class="v-data-table__td text-center">—</td>
                    </tr>
                  </template>
                  <template #no-data>
                    <div class="py-6 text-center text-medium-emphasis">
                      <v-icon size="64" color="grey-lighten-1" class="mb-2">mdi-clock-alert-outline</v-icon>
                      <div class="text-h6 text-grey mt-4">No Outstanding Bonus Found</div>
                      <div class="text-body-2 text-grey">All bonuses have been paid or no unpaid bonuses exist</div>
                    </div>
                  </template>
                </v-data-table>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script setup>
import { ref, reactive, computed, getCurrentInstance, onMounted } from 'vue'
import { toast } from 'vue3-toastify'
import { useStore } from 'vuex'

const instance = getCurrentInstance()
const appContext = instance?.appContext
const store = useStore()
const panel = ref([0])
const listPanel = ref([0])
const loading = ref(false)
const itemsPerPage = ref(10)
const search = ref('')
const reportData = ref([])

// Options
const months = [
  { label: 'January', value: 1 },
  { label: 'February', value: 2 },
  { label: 'March', value: 3 },
  { label: 'April', value: 4 },
  { label: 'May', value: 5 },
  { label: 'June', value: 6 },
  { label: 'July', value: 7 },
  { label: 'August', value: 8 },
  { label: 'September', value: 9 },
  { label: 'October', value: 10 },
  { label: 'November', value: 11 },
  { label: 'December', value: 12 }
]

// Generate year options (from 2020 to current year + 5)
const currentYear = new Date().getFullYear()
const yearOptions = computed(() => {
  const years = []
  for (let year = 2020; year <= currentYear + 5; year++) {
    years.push(year)
  }
  return years.reverse() // Show most recent years first
})

// Data
const filters = reactive({
  year: null,
  month: null
})

const tableHeaders = [
  { title: '#SL', key: 'index', sortable: false, width: '60px', align: 'center' },
  { title: 'Employee Code', key: 'employee_code', sortable: false },
  { title: 'Employee Name', key: 'employee_name', sortable: false },
  { title: 'Year', key: 'year', sortable: false, width: '80px' },
  { title: 'Month', key: 'month', sortable: false, width: '100px' },
  { title: 'Bonus Amount', key: 'bonus_amount', sortable: false, align: 'center' },
  { title: 'Payable Amount', key: 'payable_amount', sortable: false, align: 'center' },
  { title: 'Paid Amount', key: 'paid_amount', sortable: false, align: 'center' },
  { title: 'Remaining Amount', key: 'remaining_amount', sortable: false, align: 'center' },
  { title: 'Aging (Days)', key: 'aging_days', sortable: false, align: 'center', width: '120px' },
  { title: 'Payment Status', key: 'payment_status', sortable: false, align: 'center', width: '130px' }
]

// Computed
const summary = computed(() => {
  if (!reportData.value || reportData.value.length === 0) {
    return {
      total_bonus: 0,
      total_payable: 0,
      total_paid: 0,
      total_remaining: 0,
      total_records: 0,
      unpaid_count: 0,
      partial_count: 0
    }
  }

  return reportData.value.reduce((acc, item) => {
    acc.total_bonus += parseFloat(item.bonus_amount || 0)
    acc.total_payable += parseFloat(item.payable_amount || 0)
    acc.total_paid += parseFloat(item.paid_amount || 0)
    acc.total_remaining += parseFloat(item.remaining_amount || 0)
    acc.total_records += 1
    if (item.payment_status === 'unpaid') acc.unpaid_count += 1
    if (item.payment_status === 'partial') acc.partial_count += 1
    return acc
  }, {
    total_bonus: 0,
    total_payable: 0,
    total_paid: 0,
    total_remaining: 0,
    total_records: 0,
    unpaid_count: 0,
    partial_count: 0
  })
})

// Methods
const calculateAging = (item) => {
  // Calculate days since the bonus was created
  const createdDate = item.created_at ? new Date(item.created_at) : new Date()
  const today = new Date()
  const diffTime = Math.abs(today - createdDate)
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
  return diffDays
}

const fetchBonusAgingReport = async () => {
  loading.value = true
  try {
    const sanitizedFilters = Object.fromEntries(
      Object.entries(filters).filter(([, value]) => value !== null && value !== '')
    )
    const response = await store.dispatch('getBonusAgingReport', sanitizedFilters)

    if (response.data.success) {
      // Calculate aging for each item and flatten for search
      reportData.value = (response.data.data || []).map(item => ({
        ...item,
        aging_days: calculateAging(item),
        // Flatten nested properties for search
        employee_code: item.employee?.code || '',
        employee_name: item.employee?.name || '',
        month_formatted: formatMonth(item.month || item.bonusProcessMaster?.month),
        year_value: item.year || item.bonusProcessMaster?.year || '',
        payment_status_formatted: formatPaymentStatus(item.payment_status)
      }))
    } else {
      reportData.value = []
      toast.error(response.message || 'Failed to load bonus aging report')
    }
  } catch (error) {
    reportData.value = []
    const errorMessage = error.response?.data?.message || error.message || 'Failed to load bonus aging report'
    toast.error(errorMessage)
  } finally {
    loading.value = false
  }
}

const handleFilterSubmit = () => {
  fetchBonusAgingReport()
}

const formatNumber = (value, fraction = 2) => {
  if (value === undefined || value === null || value === '' || isNaN(value)) return '0.00'
  return Number(value).toLocaleString(undefined, {
    minimumFractionDigits: fraction,
    maximumFractionDigits: fraction
  })
}

const formatMonth = (month) => {
  if (!month) return '—'
  const monthObj = months.find(m => m.value === month)
  return monthObj ? monthObj.label : month
}

const formatPaymentStatus = (status) => {
  if (!status) return 'Unpaid'
  return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase()
}

const getPaymentStatusColor = (status) => {
  if (!status) return 'orange'
  switch (status.toLowerCase()) {
    case 'unpaid':
      return 'orange'
    case 'paid':
      return 'success'
    case 'partial':
      return 'info'
    default:
      return 'grey'
  }
}

const getRemainingAmountColor = (amount) => {
  const amt = parseFloat(amount || 0)
  if (amt === 0) return 'success'
  if (amt > 50000) return 'error'
  if (amt > 20000) return 'warning'
  return 'info'
}

const getAgingColor = (days) => {
  if (!days) return 'grey'
  if (days <= 30) return 'success'
  if (days <= 60) return 'info'
  if (days <= 90) return 'warning'
  return 'error'
}

// Computed for company info
const getCurrentCompany = computed(() => {
  return store.getters.getCurrentCompany || {}
})

const getFileServerUrl = computed(() => {
  return store.getters.getFileServerUrl || ''
})

// Export functions
const exportToCSV = () => {
  if (!reportData.value || reportData.value.length === 0) {
    toast.warning('No data to export')
    return
  }

  const data = [
    ['Bonus Aging Report'],
    [`Year: ${filters.year || 'All'}`],
    [`Month: ${filters.month ? months.find(m => m.value === filters.month)?.label : 'All'}`]
  ]
  
  data.push([], ['# SL', 'Employee Code', 'Employee Name', 'Year', 'Month', 'Bonus Amount', 'Payable Amount', 'Paid Amount', 'Remaining Amount', 'Aging (Days)', 'Payment Status'], [])

  reportData.value.forEach((item, index) => {
    data.push([
      index + 1,
      item.employee?.code || '—',
      item.employee?.name || '—',
      item.year || item.bonusProcessMaster?.year || '—',
      formatMonth(item.month || item.bonusProcessMaster?.month),
      formatNumber(item.bonus_amount),
      formatNumber(item.payable_amount),
      formatNumber(item.paid_amount),
      formatNumber(item.remaining_amount),
      item.aging_days + ' days',
      formatPaymentStatus(item.payment_status)
    ])
  })

  if (reportData.value.length > 0) {
    data.push([])
    data.push([
      '', '', '', '', '', 'Total:',
      formatNumber(summary.value.total_bonus),
      formatNumber(summary.value.total_payable),
      formatNumber(summary.value.total_paid),
      formatNumber(summary.value.total_remaining),
      '',
      ''
    ])
  }

  const proxy = appContext?.config?.globalProperties
  if (proxy?.$exportTableToCSV && proxy?.$fileDate) {
    proxy.$exportTableToCSV(data, 'bonus_aging_report_' + proxy.$fileDate())
  }
}

const exportToExcel = () => {
  if (!reportData.value || reportData.value.length === 0) {
    toast.warning('No data to export')
    return
  }

  const data = [
    ['Bonus Aging Report'],
    [`Year: ${filters.year || 'All'}`],
    [`Month: ${filters.month ? months.find(m => m.value === filters.month)?.label : 'All'}`]
  ]
  
  data.push([], ['# SL', 'Employee Code', 'Employee Name', 'Year', 'Month', 'Bonus Amount', 'Payable Amount', 'Paid Amount', 'Remaining Amount', 'Aging (Days)', 'Payment Status'], [])

  reportData.value.forEach((item, index) => {
    data.push([
      index + 1,
      item.employee?.code || '—',
      item.employee?.name || '—',
      item.year || item.bonusProcessMaster?.year || '—',
      formatMonth(item.month || item.bonusProcessMaster?.month),
      formatNumber(item.bonus_amount),
      formatNumber(item.payable_amount),
      formatNumber(item.paid_amount),
      formatNumber(item.remaining_amount),
      item.aging_days + ' days',
      formatPaymentStatus(item.payment_status)
    ])
  })

  if (reportData.value.length > 0) {
    data.push([])
    data.push([
      '', '', '', '', '', 'Total:',
      formatNumber(summary.value.total_bonus),
      formatNumber(summary.value.total_payable),
      formatNumber(summary.value.total_paid),
      formatNumber(summary.value.total_remaining),
      '',
      ''
    ])
  }

  const proxy = appContext?.config?.globalProperties
  if (proxy?.$exportTableToExcel && proxy?.$fileDate) {
    proxy.$exportTableToExcel(data, 'bonus_aging_report_' + proxy.$fileDate())
  }
}

const exportToPDF = async () => {
  if (!reportData.value || reportData.value.length === 0) {
    toast.warning('No data to export')
    return
  }

  const company = getCurrentCompany.value
  const fileServerUrl = getFileServerUrl.value

  let printWindow = window.open('', 'PRINT', `width=${screen.width}, height=${screen.height}, left=0, top=0`)
  printWindow.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <meta http-equiv="X-UA-Compatible" content="ie=edge">
        <title>Bonus Aging Report</title>
        <link rel="preconnect" href="https://fonts.googleapis.com">
        <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
        <link href="https://fonts.googleapis.com/css2?family=Arimo:ital,wght@0,400..700;1,400..700&display=swap" rel="stylesheet">
        <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.8/dist/css/bootstrap.min.css" rel="stylesheet">
        <link href="https://cdn.jsdelivr.net/npm/@mdi/font@7.4.47/css/materialdesignicons.min.css" rel="stylesheet">
        <style>
          body { font-family: 'Arimo', sans-serif; margin: 0px; }
          .invoice-header { display:flex; justify-content:space-between; align-items:center; border-bottom:2px solid #eee; padding-bottom:10px; }
          .invoice-header img { max-height: 70px; max-width: 150px; }
          .table th, .table td { border: 1px solid #000; padding: 8px; vertical-align: middle; font-size: 11px; }
          .table th { background-color: #f0f0f0; color: #333; }
          .text-end { text-align: right; }
          .text-center { text-align: center; }
          h4 { font-size: 20px; color: #333; }
          p { font-size: 14px; color: #555; margin: 2px 0; }
          strong { font-weight: bold; color: #333; }
          @page { margin: 0.5in; size: letter; }
          .logo-container { display:flex; align-items:center; }
          .logo-container img { margin-left: 10px; }
          .table { width: 100%; border-collapse: collapse; table-layout: auto; }
          thead { display: table-header-group; }
          .totals-row { page-break-inside: avoid; }
          .totals-row td { font-weight: bold; background-color: #f5f5f5 !important; }
        </style>
      </head>
      <body>
        <div class="container-fluid position-relative">
          <div class="invoice-header">
            <div>
              <h4 class="text-uppercase">${company?.name || 'Company Name'}</h4>
              <p style="width:65%">${company?.address || ''}</p>
              <p><i class="mdi mdi-phone-outline"></i> ${company?.mobile || ''}</p>
              <p><i class="mdi mdi-email-outline"></i> ${company?.email || ''}</p>
              ${company?.website ? `<p><i class="mdi mdi-web"></i> ${company.website}</p>` : ''}
            </div>
            <div class="logo-container">
              ${company?.logo_thumb ? `<img src="${fileServerUrl}${company.logo_thumb}" alt="Logo" class="img-fluid">` : ''}
            </div>
          </div>
          <h4 class="text-center my-4"><strong>BONUS AGING REPORT</strong></h4>
          <div class="row mb-3">
            <div class="col-sm-8">
              <p><strong>Year:</strong> ${filters.year || 'All'}</p>
              <p><strong>Month:</strong> ${filters.month ? months.find(m => m.value === filters.month)?.label : 'All'}</p>
            </div>
            <div class="col-sm-4 text-end">
              <p><strong>Total Records:</strong> ${reportData.value.length}</p>
              <p><strong>Total Outstanding:</strong> ${formatNumber(summary.value.total_remaining)}</p>
            </div>
          </div>
          <table class="table mt-4">
            <thead>
              <tr>
                <th>SN</th>
                <th>Employee Code</th>
                <th>Employee Name</th>
                <th>Year</th>
                <th>Month</th>
                <th class="text-center">Bonus Amount</th>
                <th class="text-center">Payable</th>
                <th class="text-center">Paid</th>
                <th class="text-center">Remaining</th>
                <th class="text-center">Aging (Days)</th>
                <th class="text-center">Status</th>
              </tr>
            </thead>
            <tbody>
              ${reportData.value.map((item, index) => `
                <tr>
                  <td>${index + 1}</td>
                  <td>${item.employee?.code || '—'}</td>
                  <td><strong>${item.employee?.name || '—'}</strong></td>
                  <td>${item.year || item.bonusProcessMaster?.year || '—'}</td>
                  <td>${formatMonth(item.month || item.bonusProcessMaster?.month)}</td>
                  <td class="text-center">${formatNumber(item.bonus_amount)}</td>
                  <td class="text-center">${formatNumber(item.payable_amount)}</td>
                  <td class="text-center">${formatNumber(item.paid_amount)}</td>
                  <td class="text-center">${formatNumber(item.remaining_amount)}</td>
                  <td class="text-center">${item.aging_days} days</td>
                  <td class="text-center">${formatPaymentStatus(item.payment_status)}</td>
                </tr>
              `).join('')}
              <tr class="totals-row">
                <td>—</td>
                <td colspan="4" class="text-end"><strong>Total:</strong></td>
                <td class="text-center"><strong>${formatNumber(summary.value.total_bonus)}</strong></td>
                <td class="text-center"><strong>${formatNumber(summary.value.total_payable)}</strong></td>
                <td class="text-center"><strong>${formatNumber(summary.value.total_paid)}</strong></td>
                <td class="text-center"><strong>${formatNumber(summary.value.total_remaining)}</strong></td>
                <td class="text-center">—</td>
                <td class="text-center">—</td>
              </tr>
            </tbody>
          </table>
        </div>
      </body>
    </html>
  `)
  printWindow.moveTo(0, 0)
  printWindow.focus()
  await new Promise(resolve => setTimeout(resolve, 500))
  printWindow.print()
  printWindow.close()
}

// Initialize
onMounted(() => {
  fetchBonusAgingReport()
})
</script>

<style scoped>
.panel-header {
  font-weight: 600;
}
</style>

